import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/account/view/license.account.invoices.query.gql"
import type {
  LicenseAccountInvoicesQuery,
  LicenseAccountInvoicesQueryVariables,
} from "@/v2-backoffice-client/license/account/view/__types__/license.account.invoices.query"

type Options = QueryHookOptions<
  LicenseAccountInvoicesQuery,
  LicenseAccountInvoicesQueryVariables
>

export function useLicenseAccountInvoicesQuery(options?: Options) {
  return useQuery<
    LicenseAccountInvoicesQuery,
    LicenseAccountInvoicesQueryVariables
  >(query, options)
}
